import React, { useState, useEffect } from "react";
import { TextField, Button, Container, Typography, Box } from "@mui/material";
import styled from "styled-components";
import API from "../../../utils/api";
import MenuItem from "@mui/material/MenuItem";

const FormContainer = styled(Container)`
  background-color: #1b1a2ea9;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0px 10px 10px 0px rgba(9, 5, 29, 0.171);
  backdrop-filter: blur(15px);
  color: white;
`;

const StyledTextField = styled(TextField)`
  & .MuiInputBase-root {
    color: white;
  }
  & .MuiInputLabel-root {
    color: white;
  }
  & .MuiOutlinedInput-root {
    & fieldset {
      border-color: white;
    }
    &:hover fieldset {
      border-color: #c770f0;
    }
    &.Mui-focused fieldset {
      border-color: #c770f0;
    }
  }
  margin-bottom: 1rem;
`;

const StyledButton = styled(Button)`
  background-color: #623686;
  color: white;
  margin-left: 1rem;
  margin-right: 1rem;
  &:hover {
    background-color: #6d20c5d7;
  }
`;

const TodaysLearningForm = () => {
  const [data, setData] = useState([{ name: "ggg", _id: "learning" }]);
  const [learningData, setTodaysLearningData] = useState({
    _id: "",
    title: "",
    description: "",
    link: "",
    category: "None",
    entry: "Default",
  });
  const [categories, setCategories] = useState([
    {
      value: "None",
      label: "None",
    },
  ]);
  const [saved, setSaved] = useState(true);
  useEffect(() => {
    // Load initial data on component mount
    API.get("/api/learning/saveData")
      .then((res) => res.data)
      .then((response) => {
        setData(response.saveData);
        setTodaysLearningData(
          response.saveData.find((entry) => entry.name === "Default")
        );
        setCategories(response.categories);
      })
      .catch((error) => {
        console.error("There was an error fetching the initial data!", error);
      });
  }, []);

  const handleChange = (e) => {
    setTodaysLearningData({ ...learningData, [e.target.name]: e.target.value });
    setSaved(false);
  };

  const saveData = async (data = learningData) => {
    try {
      await API.post("/api/learning/saveData", data).then((res) => {
        if (res.data.success) {
          setSaved(true);
        }
      });
    } catch (error) {
      console.error(error);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = (currentDate.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-based, so add 1
    const day = currentDate.getDate().toString().padStart(2, "0");

    const formattedDate = `${year}-${month}-${day}`;
    try {
      await API.post("/api/learning/addToday", {
        ...learningData,
        date: currentDate,
        str_date: formattedDate,
      }).then(() => {
        setTodaysLearningData({
          _id: learningData._id,
          title: "",
          description: "",
          link: "",
          category: "",
        });
      });
      alert("Learning Added successfully");
    } catch (error) {
      console.error(error);
      alert("Error submitting Learning");
    }
  };
  return (
    <Container fluid className="resume-section">
      <FormContainer maxWidth="md">
        <Typography variant="h4" gutterBottom className="purple">
          Update Learning
        </Typography>
        <form onSubmit={handleSubmit}>
          <StyledTextField
            size="small"
            fullWidth
            select
            variant="outlined"
            label="Entry"
            name="name"
            defaultValue="Default"
            value={learningData.name}
            onChange={(e) => {
              if (e.target.value !== "create_new_123") {
                const entry = data.find(
                  (entry) => entry._id === e.target.value
                );
                setTodaysLearningData(entry);
              } else {
                setTodaysLearningData({
                  title: "",
                  name: "create_new_123",
                  _id: "create_new_123",
                  description: "",
                  link: "",
                  category: "",
                });
              }
            }}
          >
            {data.map((option) => (
              <MenuItem key={option.name} value={option._id}>
                {option.name}
              </MenuItem>
            ))}
            <MenuItem key="create_new_123" value="create_new_123">
              Create New...
            </MenuItem>
          </StyledTextField>
          <StyledTextField
            size="small"
            fullWidth
            variant="outlined"
            label="Title"
            name="title"
            value={learningData.title}
            onChange={handleChange}
            required
          />
          <StyledTextField
            size="small"
            fullWidth
            variant="outlined"
            label="Link"
            name="link"
            value={learningData.link}
            onChange={handleChange}
          />
          <StyledTextField
            size="small"
            fullWidth
            select
            variant="outlined"
            label="Category"
            name="category"
            value={learningData.category}
            onChange={handleChange}
            required
          >
            {categories.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </StyledTextField>
          <StyledTextField
            size="small"
            fullWidth
            variant="outlined"
            label="Description"
            name="description"
            multiline
            minRows={4}
            maxRows={20}
            value={learningData.description}
            onChange={handleChange}
            required
          />
          <Box mt={2}>
            <StyledButton variant="contained" type="submit">
              Submit
            </StyledButton>
            {!saved && (
              <StyledButton
                variant="contained"
                onClick={(e) => {
                  e.preventDefault();
                  saveData();
                }}
              >
                Save
              </StyledButton>
            )}
          </Box>
        </form>
      </FormContainer>
    </Container>
  );
};

export default TodaysLearningForm;
